<template>
  <div class="not-found-page">
    <vue-headful :title="`404 Not Found • ${appName}`" />
    <div class="centered">
      <h1>404</h1>
      <p>{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound404",
  props: {
    message: {
      type: String,
      default: "The page you requested could not be found.",
    },
  },
};
</script>
